import script from "./discover.vue?vue&type=script&setup=true&lang=js"
export * from "./discover.vue?vue&type=script&setup=true&lang=js"

import "./discover.vue?vue&type=style&index=0&id=29f0b3c9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29f0b3c9"]])

export default __exports__